import { render, staticRenderFns } from "./MedicalRecord.vue?vue&type=template&id=468e976e&scoped=true&"
import script from "./MedicalRecord.vue?vue&type=script&lang=tsx&"
export * from "./MedicalRecord.vue?vue&type=script&lang=tsx&"
import style0 from "./MedicalRecord.vue?vue&type=style&index=0&id=468e976e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468e976e",
  null
  
)

export default component.exports